module.exports = __webpack_public_path__ + "img/image1.15dda0bc.jpg";